export class AppSettings {
    // static AdminPortalEndpoint = "https://mds-local.azurewebsites.net";
    static AdminPortalEndpoint = "https://datal-adminportal-api.azurewebsites.net";
    // static AdminPortalEndpoint = "http://localhost:4001";
    static OrgServiceVersion = "1.1";
    static ImsLoginEndpoint = "https://uat-api.digitalvault.cloud/IDM/ims/connect/authorize";
    static ImsLogoutEndpoint = "https://uat-api.digitalvault.cloud/IDM/ims/connect/endsession";
    static ImsClientId = "adminportal.web.ui";
    static ImsScopes = "openid offline_access all_claims read write securityapi_all";
    static ImsResponseType = "code+id_token+token";

    static AccuWeatherLink = "https://developer.accuweather.com/apis";
    static OpenWeatherMapLink = "https://openweathermap.org/api";
    static AerisWeatherLink = "http://www.aerisweather.com/support/docs/api/";
    static BreezoMeterLink = "https://breezometer.com/air-quality-api/";
     static AdminActiveViewName = "admin";
     static DashBoardActiveViewName="dashboard";
     static viewList:{featuerName:string,belongTo:string,searchText:Array<string>}[]=[
        { featuerName:"WEATHER_ELEMENT",belongTo:AppSettings.DashBoardActiveViewName,searchText:["/weatherstatus"]},
        { featuerName:"STATUS_ELEMENT",belongTo:AppSettings.DashBoardActiveViewName,searchText:["/apistatus"]},
        { featuerName:"ASSURANCE_DASHBOARD_ELEMENT",belongTo:AppSettings.DashBoardActiveViewName,searchText:["/assuranceDashboard"]},
        { featuerName:"IMS_SECURITY_ELEMENT",belongTo:AppSettings.AdminActiveViewName,searchText:["/ims"]},
         { featuerName:"TIMESERIES_ELEMENT",belongTo:AppSettings.AdminActiveViewName,searchText:["/timeseries"]},
          { featuerName:"ENTITY_ELEMENT",belongTo:AppSettings.AdminActiveViewName,searchText:["/entity","/application"]}
    ];
    
}